import { render } from "./HeaderBasic.vue?vue&type=template&id=4baa65a4&scoped=true"
import script from "./HeaderBasic.vue?vue&type=script&lang=js"
export * from "./HeaderBasic.vue?vue&type=script&lang=js"

import "./HeaderBasic.vue?vue&type=style&index=0&id=4baa65a4&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src951381844/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4baa65a4"]])

export default __exports__